import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from "@angular/core";
import * as fromStore from '../../../store';
import {Store} from "@ngrx/store";
import {ActivityStatus} from "../../../activities/activity";
import {combineLatest} from "rxjs";
import {UserSubscription} from "../../../user/user-subscription";
import {filter, first, switchMap, takeUntil} from "rxjs/operators";
import {User} from "../../../user/user";
import {Subject} from "rxjs";
import {DbActiveModal} from "../../../modules/modal/modal-ref";
import {Utils} from "../../../shared/utils/utils";

@Component({
    selector: 'db-clone-progress',
    templateUrl: './clone-progress.component.html',
    styleUrls: ['./clone-progress.component.scss'],
    standalone: false
})
export class CloningProgressComponent implements OnInit, OnDestroy {

  @Input() websiteUrl: string;
  @Input() dataCenter: string;
  @Input() fromNotifs: boolean = false;

  user: User;
  userSubscription: UserSubscription;
  websiteId: number;
  succeed = false;

  @Output() failed = new EventEmitter<void>();

  private _destroyStream$: Subject<boolean> = new Subject<boolean>();

  protected readonly Utils = Utils;

  constructor(
    private _store: Store<fromStore.DbStoreState>,
    private readonly activeModal: DbActiveModal,
  ) {
  }

  ngOnInit() {
    this.fromNotifs ? this.resize(174) : this.resize(218);
    this.activeModal.hideCloseBtn(true);
    this._getUserData();
    this._getOngoingActivities();
  }

  public closeDialog(): void {
    this.activeModal.close();
  }

  private _getUserData(): void {
    combineLatest(
      this._store.select(fromStore.getUser),
      this._store.select(fromStore.getUserSubscription)
    )
      .pipe(first(([user, userSubscription]) => !!user && !!userSubscription))
      .subscribe(([user, userSubscription]) => {
        this.user = user;
        this.userSubscription = userSubscription;
      });
  }

  private _getOngoingActivities(): void {
    const subscription = this._store.select(fromStore.getOngoingActivities)
      .pipe(
        first(loaded => !!loaded),
        switchMap(() => this._store.select(fromStore.getMigrationOngoingActivity)),
        filter(activity => activity && !!activity.status && [ActivityStatus.DONE, ActivityStatus.FAILED].includes(activity.status as ActivityStatus)),
        takeUntil(this._destroyStream$)
  )
      .subscribe((activity) => {

        switch (activity.status) {
          case ActivityStatus.DONE:
            subscription && subscription.unsubscribe();
            this.websiteId = activity.websiteId;
            this._store.dispatch(new fromStore.LoadInfo(this.websiteId));
            this.succeed = true;
            this.getClonedWebsite();
            this.resize(286);
            break;

          case ActivityStatus.FAILED:
            subscription && subscription.unsubscribe();
            this.failed.emit();
            break;
        }
      });
  }

  getClonedWebsite() {
    this._store.select(fromStore.getWebsite(this.websiteId))
      .pipe(first(website => !!website))
      .subscribe(website => {
        this.websiteUrl = website?.site_url;
      });
  }

  public resize(height) {
    this.activeModal.resize(height, 700);
  }

  ngOnDestroy(): void {
    this._destroyStream$.next(true);
    this._destroyStream$.complete();
  }

  protected readonly close = close;
}
